/* eslint-disable @typescript-eslint/no-explicit-any */
import { Image, Table } from 'antd';
import { RightOutlined } from '@ant-design/icons';
// import { useState } from 'react';
import { getPlanInfo } from '../planUtils';
// Two-plan (Basic/Plus) upgrade/downgrade is disabled — CAP ships a single plan.
// Kept commented for easy restore when the tiers are real again.
// import { usePlanChange } from '../usePlanChange';
// import PlanChangeModal from '../PlanChangeModal';
import styles from './index.module.scss';
import './index.scss';

const ActiveConnectionsTable = (props: any) => {
	const { Column } = Table;

	const { data, onManage } = props;

	// Plan + billing info from the company's Outseta subscription (profile data).
	const getPlan = (record: any) => getPlanInfo(record?.subscription);

	// --- Plan change (Upgrade / Downgrade) — DISABLED: single plan only ---
	// const { changePlan, isLoading: isPlanChanging } = usePlanChange();
	// const [planModal, setPlanModal] = useState<any>({
	// 	open: false,
	// 	action: 'upgrade',
	// 	company: '',
	// 	fromPlan: '',
	// 	toPlan: '',
	// 	fromPrice: 0,
	// 	toPrice: 0,
	// 	renews: '',
	// 	record: null,
	// });
	//
	// const openPlanModal = (companyRow: any, plan: any) => {
	// 	const isPlus = plan?.isPlus;
	// 	setPlanModal({
	// 		open: true,
	// 		action: isPlus ? 'downgrade' : 'upgrade',
	// 		company: companyRow?.company?.title,
	// 		fromPlan: plan?.name,
	// 		toPlan: isPlus ? 'Basic' : 'Plus',
	// 		fromPrice: plan?.price,
	// 		toPrice: isPlus ? 50 : 70,
	// 		renews: plan?.renewalDate || '—',
	// 		record: companyRow,
	// 	});
	// };
	//
	// const closePlanModal = () => {
	// 	setPlanModal((prev: any) => ({ ...prev, open: false }));
	// };
	//
	// const confirmPlanChange = () => {
	// 	changePlan(planModal.record, planModal.action, closePlanModal);
	// };

	return (
		<div className={`${styles['main-container']} integrations-sub-table`}>
			<Table
				dataSource={data?.filter((item: any) => item.isCompanyAdmin)}
				className={styles['sub-table']}
				pagination={false}
				scroll={{ y: '59vh' }}
				rowKey={(record: any) => {
					return record.key;
				}}
			>
				<Column
					title="Company"
					dataIndex="company"
					key="company"
					render={(company: any, record: any) => (
						<div className={styles['sub-table__company']}>
							<p className={styles['sub-table__company-name']}>
								{company?.title}
							</p>
							{getPlan(record).renewalDate && (
								<p className={styles['sub-table__company-renews']}>
									Renews {getPlan(record).renewalDate}
								</p>
							)}
							<p className={styles['sub-table__company-renews']}>
								Last sync {record?.last_sync}
							</p>
						</div>
					)}
				/>
				<Column
					title="Integrations"
					dataIndex="action"
					key="integrations"
					width={260}
					render={(_: any, record: any) => (
						<div className={styles['sub-table__integrations']}>
							<Image
								src={record?.accounting_software}
								preview={false}
								className={styles['sub-table__logo']}
								width={88}
							/>
							{record?.action ? (
								<span
									className={`${styles['sub-table__status']} ${styles['sub-table__status--connected']}`}
								>
									1 connected
								</span>
							) : (
								<span
									className={`${styles['sub-table__status']} ${styles['sub-table__status--disconnected']}`}
								>
									1 disconnected
								</span>
							)}
						</div>
					)}
				/>
				{/* Two-plan tier column — DISABLED (single plan only).
				<Column
					title="Plan"
					key="plan"
					width={120}
					render={(_: any, record: any) => {
						const plan = getPlan(record);
						return (
							<span
								className={`${styles['sub-table__plan']} ${
									plan.isPlus
										? styles['sub-table__plan--plus']
										: styles['sub-table__plan--basic']
								}`}
							>
								{plan.name}
							</span>
						);
					}}
				/> */}
				<Column
					title="Price"
					key="price"
					width={140}
					render={(_: any, record: any) => {
						const plan = getPlan(record);
						return (
							<span className={styles['sub-table__price']}>
								${plan.price}/{plan.interval}
							</span>
						);
					}}
				/>
				<Column
					title={() => <div style={{ textAlign: 'right' }}>Action</div>}
					dataIndex="action"
					key="action"
					width={300}
					render={(_: any, record: any) => {
						// const plan = getPlan(record); // used only by the disabled plan button
						return (
							<div className={styles['sub-table__action']}>
								{/* Upgrade/Downgrade button — DISABLED (single plan only).
								<button
									className={`${styles['sub-table__plan-btn']} ${
										plan.isPlus
											? styles['sub-table__plan-btn--outline']
											: styles['sub-table__plan-btn--solid']
									}`}
									onClick={() => openPlanModal(record, plan)}
								>
									{plan.isPlus ? 'Downgrade to Basic' : 'Upgrade to Plus'}
								</button> */}
								<span
									className={styles['sub-table__manage']}
									onClick={() => onManage && onManage(record)}
								>
									Manage <RightOutlined />
								</span>
							</div>
						);
					}}
				/>
			</Table>

			{/* Plan change modal — DISABLED (single plan only).
			{planModal.open && (
				<PlanChangeModal
					open={planModal.open}
					action={planModal.action}
					company={planModal.company}
					fromPlan={planModal.fromPlan}
					toPlan={planModal.toPlan}
					fromPrice={planModal.fromPrice}
					toPrice={planModal.toPrice}
					renews={planModal.renews}
					onConfirm={confirmPlanChange}
					onCancel={closePlanModal}
					isLoading={isPlanChanging}
				/>
			)} */}
		</div>
	);
};

export default ActiveConnectionsTable;
